import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {GeneralService} from '../../services/general.service';
import {LoadingController, ModalController} from '@ionic/angular';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {NewDocumentService} from '../../services/new-document.service';
import {SignDocumentPage} from '../sign-document/sign-document.page';
import {TestConnectionService} from '../../services/test-connection.service';
import {StateManagerService} from '../../services/state-manager.service';
import {DocumentTypes} from '../../definitions/document-types';
import {CollectionsNames} from '../../definitions/collections-names';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {ContractPage} from '../contract/contract.page';
import {ContractHealthCare} from '../healthcare/contract-health-care/contract-health-care';
import {GenerateDocFromOrderService} from '../../services/generate-doc-from-order.service';
import {SignDocumentHealthCarePage} from '../healthcare/sign-document-health-care/sign-document-health-care.page';
import { HmheadDocTypes } from 'src/app/definitions/hmhead-doctypes';
import { LiveContractResourceService } from 'src/app/services/database/resource/live-contract-resource.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ConfigurationModel } from 'src/app/models/configuration.model';
import { ContractCreationFromCollectionHealtcareService } from 'src/app/services/contract-creation-from-collection-healtcare.service';
import { CustomerResourceService } from 'src/app/services/database/resource/customer-resource.service';

@Component({
    selector: 'app-queued-live-contracts',
    templateUrl: './queued-live-contracts.page.html',
    styleUrls: ['./queued-live-contracts.page.scss'],
})
export class QueuedLiveContractsPage implements OnInit {


    queuedDocs: DocumentModel[];
    document: DocumentModel;
    queryText = '';
    loading: any;
    mobileConfig: MobileConfigurationModel;
    config: ConfigurationModel;
    @Input() type: number;
    @Input() searchDocument: DocumentModel;

    constructor(private generalServices: GeneralService,
                public modalController: ModalController,
                private refreshDataBase: RefreshdatabaseService,
                private newDocumentService: NewDocumentService,
                private loadingController: LoadingController,
                private testConnection: TestConnectionService,
                private stateManager: StateManagerService,
                private docTypes: DocumentTypes,
                private hmheadTypes: HmheadDocTypes,
                private collectionNames: CollectionsNames,
                private generateDocFromOrder: GenerateDocFromOrderService,
                private liveContractResourceService: LiveContractResourceService,
                private customerResourceService:  CustomerResourceService) {
    }

    ngOnInit() {
        this.mobileConfig = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION);
        this.config =  this.stateManager.getCollection(this.collectionNames.CONFIGURATION);
    }

    ionViewWillEnter() {
        this.loadingFetchingDocs();

    }

    setIconDoc(id: any) {
        return this.generalServices.setIcon(id);
    }

    async loadingFetchingDocs() {
        await this.loadingController.create({
            message: 'Please wait...',
            translucent: true,
            cssClass: 'custom-class custom-loading'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
        try {
            await this.fetchDocs().then(() => {
                this.loading.dismiss();
            });
        } catch (e) {
            console.log(e);
            this.generalServices.createToast('No connection with the server');
        } finally {
            this.loading.dismiss();
        }
    }

    refreshDocs(event: CustomEvent<any>) {
        this.fetchDocs().then(() => {
            // @ts-ignore
            event.target.complete();
        }).catch(() => {
            // @ts-ignore
            event.target.complete();
        });
    }

    async fetchDocs() {

        if( this.type === 1){
            this.queuedDocs = await this.customerResourceService.getContracts( this.searchDocument.customer.id ) as DocumentModel[]; 
        }
        if ( this.type === 2 ){
            this.queuedDocs = await this.liveContractResourceService.getLiveContractsForPlant( this.searchDocument.equipment[0] ) as DocumentModel[];
        }

        if ( this.type === 3 ) {
            this.queuedDocs = await this.liveContractResourceService.getLiveContractsForDepotALL(this.config.selectedDepot) as DocumentModel[]; // this.stateManager.getCollection(this.collectionNames.QUEUEDDOCUMENTS);
        }

        this.filterSignDocuments();
        this.queuedDocs.sort((a, b) => (a.documentNumber > b.documentNumber) ? 1 : -1);
        console.log(this.queuedDocs);
    }

    private filterSignDocuments() {
        const documents = this.stateManager.getCollection(this.collectionNames.DOCUMENT) as DocumentModel[];
        this.queuedDocs = this.queuedDocs.filter(qDoc => {
            for (const doc of documents) {

                if (qDoc.documentType === 6) {
                    let willInclude = true;
                    for (const doc of documents) {
                        if (doc.parentDocument && doc.parentDocument.documentNumber === qDoc.documentNumber) {
                            willInclude = false;
                        }
                    }
                    
                    return willInclude;
                }


                if (doc.documentNumber === qDoc.documentNumber) {
                    return false;
                }
            }
            return true;
        });
    }

    async openModalDocument(doc: DocumentModel) {
        console.log(doc);

        doc.originalDocumentType=1; // marks this as an existing contract we are modifying

        const modal = await this.modalController.create({
            component: ContractPage,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': doc
            }
        });

        modal.onDidDismiss().then(res => {
            if (res.data) {
                this.modalController.dismiss();
            }
        });
        return await modal.present();

    }

    cancelDocument() {
        this.modalController.dismiss();
    }

    docTypeDisplay(doc: DocumentModel) {
        if (doc.documentType === this.docTypes.SIGNDOCUMENT && doc.originalDocumentType === this.hmheadTypes.OFFHIRE ) {
            return 'Collection -';
        } else if (doc.documentType === this.docTypes.SIGNDOCUMENT && doc.originalDocumentType === this.hmheadTypes.RETURN ) {
            return 'Return -';
        } else if (doc.documentType === this.docTypes.SIGNDOCUMENT && doc.originalDocumentType === this.hmheadTypes.CONTRACT ) {
            return 'Delivery -';
        } else if (doc.documentType === 5) { // Doc Type 5 is Order in the backend
            return 'Order -';
        } else  if (doc.documentType === this.docTypes.SIGNDOCUMENT && doc.originalDocumentType === this.hmheadTypes.BREAKDOWN_COLLECTION ) {
            return 'Breakdown Collection -';
        } else  {
            return '';
        }
    }
}
